import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { LoadingScreen } from '@/components/ui/loading-screen';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isInitialized } = useAuth();

  if (!isInitialized) return <LoadingScreen onComplete={() => {}} />;
  if (!user) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
